import { HStack, Text } from "@chakra-ui/react";
import AvatarGroupClient from "./AvatarGroupClient";

export const JoinThousands = ({
  textColor = "brand.secondary",
}: {
  textColor?: string;
}) => {
  return (
    <HStack gap="12px">
      <AvatarGroupClient />
      <Text color={textColor} fontSize="14px" fontWeight="500" maxW="280px">
        Be one of the thousands taking control of their future with{" "}
        <Text as="span" fontWeight="700">
          Mindset
        </Text>
        . Join us today!
      </Text>
    </HStack>
  );
};
